<script>
import {ref} from "vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import useClipboard from "vue-clipboard3";

export default {
  name: "SupportPage",

  setup() {

    let store = useStore()
    let loading = ref(false)
    let ticket = ref({
      title: null,
      description: '',
    })


    function sent_ticket() {

      if (ticket.value.title === null) {Swals.Fault('لطفا موضوع تیکت خود را انتخاب کنید!');return false}
      if (ticket.value.description.trim().length === 0) {Swals.Fault('لطفا مشکل خود را شرح دهید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(ticket.value , 'add_ticket' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('تیکت شما با موفقیت ثبت شد')
          ticket.value = {
            title: null,
            description: '',
          }
        }else {
          Swals.Fault('متاسفانه تیکت شما ثبت نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , sent_ticket)
      })

    }


    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.Info.phone;
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    return {

      loading,
      ticket,
      sent_ticket,
      call_support,

    }
  }
}
</script>


<template>

  <div id="main" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">ارتباط با پشتیبانی</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-3 position-relative">

      <p class="font-4 font-color d-flex align-items-center mb-3">
        <span class="font-bold">انتخاب موضوع</span>
        <span class="mr-2">(الزامی)</span>
      </p>

      <div class="">

        <div class="bg-white rounded-3 d-flex align-items-center p-3 mb-2">
          <input v-model="ticket.title" class="ml-3" id="problem_app" name="support" value="گزارش مشکل خاص در اپلیکیشن"
                 type="radio">
          <label for="problem_app" class="font-4">گزارش مشکل خاص در اپلیکیشن</label>
        </div>

        <div class="bg-white rounded-3 d-flex align-items-center p-3 mb-2">
          <input v-model="ticket.title" class="ml-3" id="problem_orders" name="support" value="بروز مشکل در سفارش"
                 type="radio">
          <label for="problem_orders" class="font-4">بروز مشکل در سفارش</label>
        </div>

        <div class="bg-white rounded-3 d-flex align-items-center p-3 mb-2">
          <input v-model="ticket.title" class="ml-3" id="comment" name="support" value="انتقاد و پیشنهاد" type="radio">
          <label for="comment" class="font-4">انتقاد و پیشنهاد</label>
        </div>

        <div class="bg-white rounded-3 d-flex align-items-center p-3 mb-2">
          <input v-model="ticket.title" class="ml-3" id="more" name="support" value="سایر موارد" type="radio">
          <label for="more" class="font-4">سایر موارد</label>
        </div>

      </div>

      <p class="font-4 font-color d-flex align-items-center mt-5 mb-3">
        <span class="font-bold">مشکل خود را توضیح دهید</span>
        <span class="mr-2">(الزامی)</span>
      </p>

      <textarea v-model="ticket.description" style="height: 20vh; resize: none" class="shadow-custom bg-white font-4 w-100 rounded-4 p-3 mb-4"></textarea>


      <v-btn @click="sent_ticket" class="h-100 bg-color text-white text-center font-4 rounded-4 p-3 w-100 h-100 shadow-custom">ثبت تیکت</v-btn>


      <div dir="ltr" class="w-100 my-4">
        <div class="d-flex align-items-center mb-3">
          <router-link :to="{name:'MyTickets'}" class="text-decoration-none d-flex align-items-center">
          <img style="height: 7vh" src="../assets/img/ticket_chats.svg" alt="">
          <p class="bg-color font-5 rounded-pill py-2 px-3 ml-2 text-white">تیکت های من</p>
          </router-link>
        </div>

        <div class="d-flex align-items-center">
          <div @click="call_support" class="d-flex align-items-center">
          <img style="height: 7vh" src="../assets/img/ticket_phone.svg" alt="">
          <p class="bg-color font-5 rounded-pill py-2 px-3 ml-2 text-white">تماس مستقیم</p>
          </div>
        </div>
      </div>

    </div>


  </div>

</template>


<style scoped>

</style>